import { render, staticRenderFns } from "./ModalV2.vue?vue&type=template&id=77ca95b3&"
import script from "./ModalV2.vue?vue&type=script&lang=js&"
export * from "./ModalV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports